import { connect } from 'react-redux';
import { actionCreators } from '../../dux/notifications';
import Banner from './Banner';
import getBannerNotificationsState from '../../dux/notifications/selectors';
import { getOrgState } from '../../dux/org/selectors';
import { actionCreators as userActionCreators, selectors } from '../../dux/user';
import { actionCreators as orgActionCreators } from '../../dux/org';

const mapStateToProps = (state) => ({
  ...getBannerNotificationsState(state),
  org: { ...getOrgState(state) },
  user: selectors.getIdentityState(state),
});

const mapDispatchToProps = {
  activateBanner: actionCreators.activateBanner,
  removeBanner: actionCreators.removeBanner,
  enqueueBanner: actionCreators.enqueueBanner,
  setFreeCreditAware: actionCreators.setFreeCreditAware,
  stopOrgImpersonation: userActionCreators.stopOrgImpersonation,
  getOrg: orgActionCreators.getOrg,
};

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
